import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { getCurrentSessionToken, isAuthUser } from "../Service/Auth.service";
import MobileNumber from "./Components/MobileNumber";
import Loading from "src/Shared/Components/Loading";
import { MyRestaurantState } from "src/MyRestaurant/State";
import ImageSlider from "./Components/Carousel/ImageSlider";
import { SliderData } from "./Components/Carousel/SliderData";
import { DEFAULT_RESTAURANT_BRAND_COLOR } from "src/constant";
import { applyPrimaryColor } from "src/Shared/Utils/HTMLUtils";

type CombinedProps = MyRestaurantState;

const LoginPageComponent = ({ selectedRestaurant }: CombinedProps) => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [loading, setLoading] = useState(false);
  // const dispatch = useDispatch();

  const [mobileNumberRefId, setMobileNumberRefId] = useState<string>("");
  const [otpRefId, setotpRefId] = useState<string>("");
  const [currentSlide, setCurrentSlide] = useState<number>(0);
  const [isPWAError, setIsPWAError] = useState(false);

  // const { push } = useHistory();

  const history = useHistory();

  const CHECK_LIST_ROUTE_PATH = "/loading";

  const handleOnSlideChange = (slide: number) => {
    setCurrentSlide(slide);
  };

  const handleLoadingChange = (value: boolean) => {
    setLoading(value);
  };

  const handleOtpRefIdChange = (value: string) => {
    setotpRefId(value);
  };

  const redirectToChecklistRouteIfAuthenticated = () => {
    const isauthUser = isAuthUser();
    if (isauthUser) {
      history.push(CHECK_LIST_ROUTE_PATH);
    }
  };
  useEffect(() => {
    const isauthUser = isAuthUser();
    applyPrimaryColor(DEFAULT_RESTAURANT_BRAND_COLOR);
    if (isauthUser) {
      redirectToChecklistRouteIfAuthenticated();
    } else {
      localStorage.clear();
      acquireSessionToken();
      window.history.pushState(null, document.title, window.location.href);
    }
  }, []);

  const onChangeMobile = (mobileNumber: string) => {
    setMobileNumber(mobileNumber);
  };

  const onChangeMobileRefId = (mobileRefId: string) => {
    setMobileNumberRefId(mobileRefId);
  };

  const acquireSessionToken = async () => {
    localStorage.clear();
    setLoading(true);
    const result = await getCurrentSessionToken();
    
    if (result.token) {
      localStorage.setItem("sessionToken", result.token);
    }
    setLoading(false);
  };
  const handlePWAError = (value: boolean) => {
    setIsPWAError(value);
  };
  if (loading) {
    return <Loading />;
  }
  return (
    <>
      <main>
        <div className="auth-container">
          <div className="auth-container__banner">
            <ImageSlider
              slides={SliderData}
              handleOnSlideChange={handleOnSlideChange}
            />
          </div>

          <MobileNumber
            onChangeMobile={onChangeMobile}
            onChangeMobileNumberRefId={onChangeMobileRefId}
            mobileNumberRefId={mobileNumberRefId}
            onChangeOtpRefId={handleOtpRefIdChange}
            otpRefId={otpRefId}
            mobileNumber={mobileNumber}
            onLoadingChange={handleLoadingChange}
            loading={loading}
            currentSlide={currentSlide}
            handlePWAError={handlePWAError}
            isPWAError={isPWAError}
          />
        </div>
      </main>
    </>
  );
};

export default LoginPageComponent;
